// extracted by mini-css-extract-plugin
export default {"container":"announcement_container__ODIFt"};